module.exports = __webpack_public_path__ + "img/mastercard-data.0aeac33a.svg";